<template>
  <div class="app" id="app" :style="appStyle">
    <AppHeader @init="initHeader"/>
    <div class="app-body" id="app-body"  :style="{marginTop:appBodyMarginTop}">
      <Sidebar/>
      <main class="main" style="z-index: 1" :style="{marginLeft:mainMarginleft}">
        <breadcrumb :list="list"/>
        <div class="container-fluid" :style="{overflow:overflow1}">
          <router-view></router-view>
        </div>
      </main>
    <!--  <AppAside/>-->
    </div>
    <div style="height: 20px;background-color: rgb(242, 244, 250);"></div>
    <!--<AppFooter/>-->
  </div>
</template>

<script>
import AppHeader from '../components/Header'
import Sidebar from '../components/Sidebar'
import AppAside from '../components/Aside'
import AppFooter from '../components/Footer'
import Breadcrumb from '../components/Breadcrumb'
import CeiAppHeader from '../components/CeiAppHeader'
import {getSystemUnitCode} from '../api/home';

export default {
  name: 'full',
  data(){
    return{
      overflow1:"",
      mainMarginleft:"290px",
        appBodyMarginTop: "65px",
      appStyle:{
        width :  window.innerWidth+"px"
      },
        flag: 0
    }
  },
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb,
    CeiAppHeader
  },
  computed: {

    name () {
      return this.$route.name
    },

    list () {
      return this.$route.matched
    }
  },
  created(){
        window.addEventListener('resize', this.handleResize);
   },
  mounted(){
    this.initStyle();
    this.changeSidebar();
  },
  methods:{
      initHeader(height){
        // this.flag = 1;
        console.log("height",height);
        this.appBodyMarginTop= (height + 1) +"px";
      },
    initStyle(){
      const width = window.innerWidth;
      const  body = $("body");
      if(width > 1280){
        body.css("overflow-x","hidden");
      }else {
        body.css("overflow-x","");
      }
      body.css("overflow-y","auto");
    },
    changeSidebar(){
        const  width = document.body.clientWidth ||document.body.scrollWidth;
        const big = this.$store.getters.sidebarBigWidth;
        const small = this.$store.getters.sidebarSmallWidth;
        const critical = this.$store.getters.sidebarCriticalValue;
        if(width > critical){
            this.mainMarginleft = big+"px";
        }else {
            this.mainMarginleft = small+"px";
        }
    },
    handleResize () {
      const  width = document.body.clientWidth ||document.body.scrollWidth;
      this.appStyle = {
        width : width+"px",
      };
      this.initStyle();
      this.changeSidebar();
    }
  }
}
</script>
<style>
  .app{
    /*min-height: 1200px;*/
    min-width: 1500px;
  }
</style>



// WEBPACK FOOTER //
// Full.vue?5210b57e